import React, { Component } from "react";
import { useParams, useNavigate, useLocation, Link } from "react-router-dom";
import { ReactComponent as IcoChevron } from "../../../res/iconos/chevron.svg";
import SubmenuGrupo from "./submenuGrupo.jsx";
import SubmenuMarcas from "./submenuMarcas.jsx";
import { createRef } from "react";
import { CSSTransition } from "react-transition-group";
import textosJSON from "./textosMenu.json";
import SubmenuIdiomas from "./submenuIdiomas.jsx";

function withRouterAndNavigate(Component) {
  function ComponentWithRouterAndNavigate(props) {
    let params = useParams();
    let navigate = useNavigate();
    let location = useLocation();
    return (
      <Component
        {...props}
        params={params}
        navigate={navigate}
        location={location}
      />
    );
  }
  return ComponentWithRouterAndNavigate;
}

class Menu extends Component {
  state = { mostrarSubmenuGrupo: false, mostrarSubmenuMarcas: false, mostrarSubmenuIdiomas: false };

  //constructor, componentDidMount, componentWillUnmount y handleClickOutside son para ocultar el submenu de productos tocando fuera de el
  constructor(props) {
    super(props);
    this.ref1 = createRef();
    this.ref2 = createRef();
    this.ref3 = createRef();
    this.handleClickOutside = this.handleClickOutside.bind(this);
  }

  componentDidMount() {
    document.addEventListener("click", this.handleClickOutside, true);
  }

  componentWillUnmount() {
    document.removeEventListener("click", this.handleClickOutside, true);
  }

  handleClickOutside(event) {
    if (this.ref1.current && !this.ref1.current.contains(event.target))
      this.setState({ mostrarSubmenuGrupo: false });
    if (this.ref2.current && !this.ref2.current.contains(event.target))
      this.setState({ mostrarSubmenuMarcas: false });
    if (this.ref3.current && !this.ref3.current.contains(event.target))
      this.setState({ mostrarSubmenuIdiomas: false });
  }

  style() {
    let style = {
      background: "transparent",
      border: "none",
    };
    if (this.props.mobile) {
      style.position = "relative";
      style.display = "block";
      style.width = "100%";
      style.padding = "30px 10%";
      style.textAlign = "left";
      style.color = "#fafafa";
      style.fontWeight = 700;
    } else {
      style.position = "relative";
      style.height =  "100%";
      style.alignContent = "center";
      style.alignSelf = "center";
      style.textAlign = "center";
    }
    return style;
  }

  render() {
    const { mobile, ocultar } = this.props;

    const paths = this.props.location.pathname.split("/");
    const pathIdioma = paths.slice(0,2).join("/");
    const pathHome = pathIdioma + "/home";
    const pathRest = paths.slice(2).join("/");

    let idioma = paths[1]
    if (!idioma.length) {
      idioma = "es"
    }
    const texto = (nombre) => {
      return (textosJSON[nombre]?.[idioma])??(textosJSON[nombre]?.["es"])??""
    }

    return (
      <nav
        style={{
          display: mobile ? undefined : "flex",
          flexGrow: 1,
          justifySelf: mobile?undefined:"flex-end",
          justifyContent: mobile?undefined:"space-between",
          justifyItems: mobile?undefined:"center",
          backgroundColor: mobile?"#242e37":"transparent",
          height: mobile ? "100vh" : "100%",
          marginTop: mobile?-150:undefined,
          width: "100%",
        }}
      >
        <div ref={this.ref1}>
          <button
            className={"itemNavBar"}
            style={this.style()}
            onClick={() => {
              this.setState({ mostrarSubmenuGrupo: !this.state.mostrarSubmenuGrupo });
            }}
            onMouseEnter={
              mobile
                ? null
                : () => {
                    this.setState({ mostrarSubmenuGrupo: true });
                  }
            }
            onMouseLeave={
              mobile
                ? null
                : () => {
                    this.setState({ mostrarSubmenuGrupo: false });
                  }
            }
          >
            {texto("nuestroGrupo")}
            <CSSTransition
              in={this.state.mostrarSubmenuGrupo}
              timeout={250}
              classNames="girar"
            >
              <IcoChevron
                width={15}
                height={15}
                style={{
                  position: mobile ? "absolute" : "static",
                  right: "10%",
                }}
                stroke={mobile?"#fafafa":"#FFFFFF"}
              />
            </CSSTransition>
            <CSSTransition
              in={this.state.mostrarSubmenuGrupo}
              timeout={250}
              classNames="submenu"
              unmountOnExit
            >
              <SubmenuGrupo mobile={mobile} ocultarMenu={ocultar} idioma={idioma}/>
            </CSSTransition>
          </button>
        </div>

        <div ref={this.ref2}>
          <button
            className={"itemNavBar"}
            style={this.style()}
            onClick={() => {
              this.setState({ mostrarSubmenuMarcas: !this.state.mostrarSubmenuMarcas });
            }}
            onMouseEnter={
              mobile
                ? null
                : () => {
                    this.setState({ mostrarSubmenuMarcas: true });
                  }
            }
            onMouseLeave={
              mobile
                ? null
                : () => {
                    this.setState({ mostrarSubmenuMarcas: false });
                  }
            }
          >
            {texto("marcas")}
            <CSSTransition
              in={this.state.mostrarSubmenuMarcas}
              timeout={250}
              classNames="girar"
            >
              <IcoChevron
                width={15}
                height={15}
                style={{
                  position: mobile ? "absolute" : "static",
                  right: "10%",
                }}
                stroke={mobile?"#fafafa":"#FFFFFF"}
              />
            </CSSTransition>
            <CSSTransition
              in={this.state.mostrarSubmenuMarcas}
              timeout={250}
              classNames="submenu"
              unmountOnExit
            >
              <SubmenuMarcas mobile={mobile} ocultarMenu={ocultar} />
              
            </CSSTransition>
          </button>
        </div>

        <Link
          className={"itemNavBar"}
          onClick={ocultar}
          to={pathIdioma + "/contact"}
          style={this.style()}
        >
          {texto("contacto")}
        </Link>
        {mobile ? 
        <>
        <div style= {{width: "80%", marginLeft: "auto", marginRight: "auto", height: 1, backgroundColor: "#41454c"}}/>
        <div ref={this.ref3}>
          <button
            className={"itemNavBar"}
            style={this.style()}
            onClick={() => {
              this.setState({ mostrarSubmenuIdiomas: !this.state.mostrarSubmenuIdiomas });
            }}
            onMouseEnter={
              mobile
                ? null
                : () => {
                    this.setState({ mostrarSubmenuIdiomas: true });
                  }
            }
            onMouseLeave={
              mobile
                ? null
                : () => {
                    this.setState({ mostrarSubmenuIdiomas: false });
                  }
            }
          >
            {texto("idiomas")}
            <CSSTransition
              in={this.state.mostrarSubmenuIdiomas}
              timeout={250}
              classNames="girar"
            >
              <IcoChevron
                width={15}
                height={15}
                style={{
                  position: mobile ? "absolute" : "static",
                  right: "10%",
                }}
                stroke={mobile?"#fafafa":"#FFFFFF"}
              />
            </CSSTransition>
            <CSSTransition
              in={this.state.mostrarSubmenuIdiomas}
              timeout={250}
              classNames="submenu"
              unmountOnExit
            >
              <SubmenuIdiomas mobile={mobile} ocultarMenu={ocultar} idioma={idioma} path={pathRest} />
            </CSSTransition>
          </button>
        </div>
        </>
        :
        <>
        <div ref={this.ref3}>
          <button
            className={"itemNavBar"}
            style={this.style()}
            onClick={() => {
              this.setState({ mostrarSubmenuIdiomas: !this.state.mostrarSubmenuIdiomas });
            }}
            onMouseEnter={
              mobile
                ? null
                : () => {
                    this.setState({ mostrarSubmenuIdiomas: true });
                  }
            }
            onMouseLeave={
              mobile
                ? null
                : () => {
                    this.setState({ mostrarSubmenuIdiomas: false });
                  }
            }
          >
            {idioma.toUpperCase()}
            <img 
              src={require("../../../res/iconos/" + idioma + ".png")}
              className="bandera_idioma"
              style={{
                position: "relative",
                objectFit: "cover",
                objectPosition: "center",
                width: 16,
                height: 11,
                margin: "auto",
                marginLeft: 11,
                zIndex: 0,
              }}
            />
            <CSSTransition
              in={this.state.mostrarSubmenuIdiomas}
              timeout={250}
              classNames="submenu"
              unmountOnExit
            >
              <SubmenuIdiomas mobile={mobile} ocultarMenu={ocultar} idioma={idioma} path={pathRest} />
            </CSSTransition>
          </button>
        </div>
        </>
        }
               
      </nav>
    );
  }
}

export default withRouterAndNavigate(Menu);
